import { MatterTemplateDictionary } from "@/components/features/settings/defaults/matter-template-dictionary/MatterTemplateDictionary";
import { MatterTemplatesTable } from "@/components/features/settings/defaults/matter-templates/MatterTemplatesTable";
import {
  Tabs,
  TabsContent,
  TabsList,
  TabsTrigger,
  Typography,
} from "@/components/ui";
import { useUser } from "@/components/UserProvider";
import { PAGE_PERMISSION_KEYS } from "@/lib/data/static/permissionOptions";
import { tabSize } from "@/lib/utils/tabSize";
import { useMemo } from "react";

export default function Templates() {
  const { hasPagePermission } = useUser();
  const hasTemplatesAccess = hasPagePermission(
    PAGE_PERMISSION_KEYS.firmTemplates,
  );

  const tabs = useMemo(
    () => [
      {
        value: "templates",
        access: hasTemplatesAccess,
      },
      {
        value: "template-dictionary",
        access: hasTemplatesAccess,
      },
    ],
    [hasTemplatesAccess],
  );

  const accessibleTabsCount = useMemo(
    () => tabs.filter((tab) => tab.access).length,
    [tabs],
  );

  const defaultTab = useMemo(
    () => tabs.find((tab) => tab.access)?.value,
    [tabs],
  );

  return (
    <div className="flex h-full min-h-0 flex-col">
      {accessibleTabsCount > 0 && (
        <div className="flex min-h-0 w-full flex-1 flex-col">
          <div className="mb-6 ml-2 gap-y-1">
            <Typography color="primary" variant="heading">
              Templates
            </Typography>
          </div>

          <Tabs
            defaultValue={defaultTab}
            className="flex min-h-0 flex-1 flex-col"
          >
            <TabsList className={`grid ${tabSize(accessibleTabsCount)}`}>
              {hasTemplatesAccess && (
                <TabsTrigger value="templates">Templates</TabsTrigger>
              )}
              {hasTemplatesAccess && (
                <TabsTrigger value="template-dictionary">
                  Template dictionary
                </TabsTrigger>
              )}
            </TabsList>
            <TabsContent
              value="templates"
              forceMount
              className="min-h-0 flex-1"
            >
              <MatterTemplatesTable />
            </TabsContent>
            <TabsContent
              value="template-dictionary"
              forceMount
              className="min-h-0 flex-1 overflow-y-auto"
            >
              <MatterTemplateDictionary />
            </TabsContent>
          </Tabs>
        </div>
      )}
    </div>
  );
}
